import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";

import { Quote } from "src/api-service";

export interface OrderSuccessDialogData {
    quote: Quote;
    dialogKey: string;
}

@Component({
    selector: "app-order-success-dialog",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonModule, TranslateModule],
    templateUrl: "./order-success-dialog.component.html",
    styleUrl: "./order-success-dialog.component.scss",
})
export class OrderSuccessDialogComponent {

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    public readonly ref = inject(DynamicDialogRef);
    private readonly config = inject<DynamicDialogConfig<OrderSuccessDialogData>>(DynamicDialogConfig);

    // =========================================================================
    // PUBLIC PROPERTIES
    // =========================================================================
    public readonly showEasterEgg = new Date() < new Date('2026-04-07T02:00:00');
    public readonly titleKey = `EFFECTS_DIALOGS.${this.config.data!.dialogKey}.SUCCESS.TITLE`;
    public readonly messageKey = `EFFECTS_DIALOGS.${this.config.data!.dialogKey}.SUCCESS.MESSAGE`;
    public readonly orderNumber = [
        (this.config.data!.quote as { latestOrder?: { orderNumber?: string } })?.latestOrder?.orderNumber,
        this.config.data!.quote?.salesOrderNo,
    ].filter(Boolean).join('\n');
}
